<app-page-title
	[title]="title"
	[subtitle]="subtitle"
	breadcrumb="Ver Lista"
	[loading]="loading"
/>

<section class="page-section container">
	<app-big-loader *ngIf="loading" />
	<app-view-user *ngIf="user" [user]="user" />
	<app-error-box *ngIf="viewErrorBox" errorMsg="Erro ao obter lista de usuário" />
	<app-ad-push />
</section>
